module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxMiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik02IDAuNUMzLjA5NzUgMC41IDAuNzUgMi44NDc1IDAuNzUgNS43NUMwLjc1IDkuNjg3NSA2IDE1LjUgNiAxNS41QzYgMTUuNSAxMS4yNSA5LjY4NzUgMTEuMjUgNS43NUMxMS4yNSAyLjg0NzUgOC45MDI1IDAuNSA2IDAuNVpNNiA3LjYyNUM0Ljk2NSA3LjYyNSA0LjEyNSA2Ljc4NSA0LjEyNSA1Ljc1QzQuMTI1IDQuNzE1IDQuOTY1IDMuODc1IDYgMy44NzVDNy4wMzUgMy44NzUgNy44NzUgNC43MTUgNy44NzUgNS43NUM3Ljg3NSA2Ljc4NSA3LjAzNSA3LjYyNSA2IDcuNjI1WiIgZmlsbD0iIzQ0NDU0NSIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/location.svg
// module id = OJY6
// module chunks = 1